const LOGIN_REDIRECT_EVENT = "uptain:login-redirect";

const requestLoginRedirect = (): void => {
  window.dispatchEvent(new Event(LOGIN_REDIRECT_EVENT));
};

export { LOGIN_REDIRECT_EVENT, requestLoginRedirect };
